import { Injectable } from '@angular/core';
import {
  Subject,
  Observable,
  of,
  BehaviorSubject,
} from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { DLSRouteStateService } from '../../../core/services/dls-route-state/dls-route-state.service';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  private _valueChanges$: Subject<any>;
  valueChanges$: Observable<any>;

  private _darkTheme$: BehaviorSubject<boolean>;
  darkTheme$: Observable<boolean>;

  constructor(private _dlsRouteState: DLSRouteStateService) {
    this._valueChanges$ = new Subject();
    this.valueChanges$ = this._valueChanges$.asObservable();

    this._darkTheme$ = new BehaviorSubject(false);
    this.darkTheme$ = this._darkTheme$.asObservable();
  }

  setDarkTheme(value: boolean) {
    this._darkTheme$.next(value);
  }

  updateHeader(activatedRoute: ActivatedRoute) {
    let isDesign = false;
    let isDevelop = false;
    let basePath = '';
    let isBasePathConstructed = false;
    let routeConfigActivatedRoute: ActivatedRoute;

    // Looping Through ActivatedRoute
    while (activatedRoute.firstChild) {
      activatedRoute = activatedRoute.firstChild;
      if (activatedRoute.routeConfig.path === 'develop') {
        isDevelop = true;
        isBasePathConstructed = true;
        routeConfigActivatedRoute = Object.assign({}, activatedRoute);
      } else if (activatedRoute.routeConfig.path === 'design') {
        isDesign = true;
        isBasePathConstructed = true;
        routeConfigActivatedRoute = Object.assign({}, activatedRoute);
      }
      if (!isBasePathConstructed && activatedRoute.routeConfig.path) {
        basePath = `${basePath}/${activatedRoute.routeConfig.path}`;
      }
    }

    // Set DLS route state
    if (isDevelop) {
      this._dlsRouteState.state = 'develop';
    } else if (isDesign) {
      this._dlsRouteState.state = 'design';
    } else {
      this._dlsRouteState.state = null;
    }

    const payLoad: { [k: string]: any } = {
      heading: '',
      basePath: basePath,
      hideHeader: false,
    };

    // Listen to route payload
    (
      routeConfigActivatedRoute
        ? routeConfigActivatedRoute.data
        : of({})
    ).pipe(
      mergeMap((data) => {
        payLoad.isDesign = data.design;
        payLoad.isDevelop = data.develop;
        payLoad.pageTabs = data.pageTabs;
        return activatedRoute.data;
      })
    ).subscribe((data) => {
      payLoad.isDesign = payLoad.isDesign !== 'undefined' ? payLoad.isDesign : data.design;
      payLoad.isDevelop = payLoad.isDevelop !== 'undefined' ? payLoad.isDevelop : data.develop;
      payLoad.pageTabs = payLoad.pageTabs !== 'undefined' ? payLoad.pageTabs : data.pageTabs;
      // To hide header on a page; eg: Home
      payLoad.hideHeader = data.hideHeader;
      payLoad.heading = data.title;
      this._valueChanges$.next(payLoad);
    });
  }
}
